import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { AuthServiceService } from '../../shareModule/services/auth-service.service';

@Component({
  selector: 'app-campaign',
  templateUrl: './campaign.component.html',
  styleUrls: ['./campaign.component.scss']
})
export class CampaignComponent implements OnInit {

  mapSearchMonthListing: any = [
    {
      listing: [
        {
          text: '',
          image_url: '',
          rowId: 0,
        },
      ],
    },
  ];
  baseUrlImgae = environment.ImageUrl;
  currentItem: any = {};

  formData: any = {
    name: '',
    link: '',
    start_date: '',
    tier: '',
  };

  // keywords: any = ['', '', '', '', '', ''];

  constructor(
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.readAllSearchMaps();
    this.readSearchMapForm();
  }
  /**
   * Opens the image selection pop-up for the specified selector.
   * @param {string} selector - The CSS selector of the element to trigger the click event.
   */
  openSelectImagePopUp(selector) {
    document.querySelector(selector).click();
  }

  /**
   * Saves the selected image and updates the corresponding data in the model.
   * @param {Event} event - The file input change event.
   * @param {number} mainIndex - The index of the main month in the mapSearchMonthListing array.
   * @param {number} listingIndex - The index of the listing in the main month.
   */
  saveSeletedImage(event, mainIndex, listingIndex) {
    let file = event.target.files[0];

    let fileReader = new FileReader();
    fileReader.onload = () => {
      this.mapSearchMonthListing[mainIndex].listing[listingIndex].image =
        fileReader.result;
      this.mapSearchMonthListing[mainIndex].listing[listingIndex].orig_file =
        file;
      this.saveData(
        this.mapSearchMonthListing[mainIndex].listing[listingIndex]
      );
    };
    fileReader.readAsDataURL(file);
  }

  /**
   * Gets the image path based on the provided image data.
   * @param imgData - The image data to be processed.
   * @returns The image path.
   */
  getImagePath(imgData) {
    // Checking if the image data already includes a base64 representation
    if (imgData.includes(';base64')) {
      // If so, the image data is already a valid path; return as is
      return imgData;
    }

    // If the image data does not include a base64 representation,
    // construct the image path using the base URL for images
    return `${this.baseUrlImgae}${imgData}`;
  }

  /**
   * Displays the image in a modal using the specified content and URL.
   * @param {any} content - The content to be displayed in the modal.
   * @param {string} url - The URL of the image to be viewed.
   */
  viewImage(content: any, item: string) {
    this.currentItem = item;
    this.modalService.open(content, { size: 'sm' });
  }

  deleteConfirmation(content) {
    this.modalService.open(content, { size: 'sm' });
  }

  deleteImage() {
    this.saveData(this.currentItem, true);
  }
  /**
   * Adds a new month to the mapSearchMonthListing array.
   */
  addNewMonth() {
    this.mapSearchMonthListing.push({
      name: this.mapSearchMonthListing.length,
      listing: [
        {
          text: '',
          image_url: '',
          rowId: this.mapSearchMonthListing.length,
        },
      ],
    });
  }

  /**
   * Adds a new listing to the specified month in the mapSearchMonthListing array.
   * @param {number} index - The index of the month to which the listing will be added.
   */
  addMonthList(index) {
    this.mapSearchMonthListing[index].listing.push({
      text: '',
      image_url: '',
      rowId: index,
    });
  }

  /**
   * Saves data by adding or updating a search map.
   * @param item - The item containing data to be saved.
   */
  saveData(item, deleteImage = false) {
    let formData = new FormData();
    if (deleteImage) {
      formData.append('isDeleteImage', '1');
      formData.append('image', '');
    } else if (item.orig_file) {
      formData.append('image', item.orig_file);
    }
    formData.append('text', item.text);
    if (item.id) {
      formData.append('id', item.id);
    }
    if (item.rowId) {
      formData.append('rowId', item.rowId);
    }
    this.auth.addOrUpdateCompaigns(formData).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        // If it's a new item (add operation), refreshing the search maps
        if (!item.id || deleteImage) {
          this.readAllSearchMaps();
          this.modalService.dismissAll();
        }
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
  /**
   * Reads and organizes search maps
   */
  readAllSearchMaps() {
    this.auth.getCompaigns().subscribe(
      (response: any) => {
        // Array to store organized search maps by month
        let mapSearchMonthListing = [];
        // Iterating through the response body to organize data
        response.body.forEach((data) => {
          let foundIndex = mapSearchMonthListing.findIndex(
            (item) => item.month == data.rowId
          );
          // Checking if the month is already present in the array
          if (foundIndex > -1) {
            // If present, adding the current data to the existing month
            mapSearchMonthListing[foundIndex].listing.push(data);
          } else {
            // If not present, creating a new entry for the month
            mapSearchMonthListing.push({
              month: data.rowId,
              listing: [data],
            });
          }
        });
        if (mapSearchMonthListing.length) {
          this.mapSearchMonthListing = mapSearchMonthListing;
        }
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  /**
   * Reads and organizes search maps form
   */
  readSearchMapForm() {
    this.auth.getCampaignsForm().subscribe(
      (response: any) => {
        if (Object.keys(response.body).length) {
          this.formData = response.body;
        }
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  /**
   * Saves data by adding or updating a search map.
   * @param item - The item containing data to be saved.
   */
  saveFormData() {
    let data = { ...this.formData };
    this.auth.updateCampaignsForm(data).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

}
